import { observable, computed, action, spy } from 'mobx';

export default class OnboardStore {
	@observable ham_found = false;
	@observable ham_is_ssl = false;
	@observable deviceDetails = { blocked: false, device_tag: '', host_name: '', model_name: '' };
	@observable deviceCode = { device_code: '', expires_in: '', interval: '', user_code: '', verification_url: '' };
	@observable error = 'Please wait...';

	readonly deviceCodeEP = 'localhost:2381/agent/api/v1/devicecode';
	readonly client_id = '1270ef73-2327-43de-abdb-397156cfdef9';
	readonly deviceDetailsEP = 'localhost:2381/agent/api/v1/device';
	readonly tokenEP = window.appConfig.VUE_APP_TOKENEP;

	constructor() {
		// spy((evt) => {
		// 	if (evt.type === 'update') {
		// 		console.log(
		// 			`%c[${evt.name.replace(/@[0-9]+/g, '')}.${evt.key}]\n%o→%o`,
		// 			'font-weight: 800; color: green',
		// 			JSON.parse(JSON.stringify(evt.oldValue)),
		// 			JSON.parse(JSON.stringify(evt.newValue))
		// 		);
		// 	}
		// });
	}

	get host() {
		return window.location.hostname;
	}

	get stack() {
		if (this.host.includes('.dev.') || this.host.includes('localhost')) {
			return 'dev';
		} else if (this.host.includes('.qa.')) {
			return 'qa';
		} else if (this.host.includes('.stg.') || this.host.includes('gnatogryz')) {
			return 'stg';
		} else if (this.host.includes('.prod.')) {
			return 'prod';
		} else {
			return 'prod';
		}
	}

	@computed get urlPrefix() {
		return this.ham_is_ssl ? 'https://' : 'http://';
	}

	@computed get deviceCodeUrl() {
		return this.urlPrefix + this.deviceCodeEP;
	}

	@computed get deviceDetailsUrl() {
		return this.urlPrefix + this.deviceDetailsEP;
	}

	@computed get tokenEndpoint() {
		return this.tokenEP.replace('[stack]', this.stack);
	}

	@action.bound
	makeRequest(url, method = 'GET', body = '', headers = {}) {
		let request = new XMLHttpRequest();

		return new Promise<{ status: number; statusText: string; body: string; isOk: boolean }>((resolve, reject) => {
			request.onreadystatechange = function() {
				if (request.readyState !== 4) return;

				if (request.status >= 200 && request.status < 300) {
					resolve({
						status: request.status,
						statusText: request.statusText,
						body: request.responseText,
						isOk: true
					});
				} else {
					reject({
						status: request.status,
						statusText: request.statusText,
						body: request.responseText,
						isOk: false
					});
				}
			};

			request.open(method || 'GET', url, true);
			for (let key in headers) {
				request.setRequestHeader(key, headers[key]);
			}

			request.send(body);
		});
	}

	@action.bound async checkHTTP() {
		let oneTwo = [];

		let uno = new Promise<string>((r, r2) => {
			this.makeRequest('http://' + this.deviceDetailsEP)
				.then((res) => {
					if (res && res.isOk) {
						this.ham_is_ssl = false;
						this.ham_found = true;
						console.log('HTTP ok');
						r(res.body);
					}
				})
				.catch((e) => {
					console.log('http is probably unavailable', e);
					r2();
				});
		});

		let dos = new Promise<string>((r, r2) => {
			this.makeRequest('https://' + this.deviceDetailsEP)
				.then((res) => {
					if (res && res.isOk) {
						this.ham_is_ssl = true;
						this.ham_found = true;
						console.log('HTTPS ok');
						r(res.body);
					}
				})
				.catch((e) => {
					console.log('https is probably unavailable', e);
					r2();
				});
		});

		try {
			let retvals = await Promise.any([uno, dos]);
			if (retvals) {
				return retvals;
			}
		} catch {
			return '';
		}

		return '';
	}

	@action.bound async getDeviceCode() {
		let resp = await this.makeRequest(this.deviceCodeUrl);
		return resp.body;
	}

	@action.bound async authRequest() {
		let headers = { 'Content-Type': 'application/x-www-form-urlencoded', Authorization: 'Basic ' + btoa(this.client_id + ':') };
		let resp = await this.makeRequest(this.tokenEndpoint, 'POST', 'code=' + this.deviceCode.device_code + '&grant_type=device_code', headers);

		return resp.body;
	}

	@action.bound async onboard(retries = 3) {
		console.log('ONBOARD:: ' + this.stack);

		let ham = '';
		try {
			ham = await this.checkHTTP();
		} catch (err) {
			console.error(err);
			if (retries) {
				this.onboard(retries - 1);
			} else {
				return;
			}
		}

		console.log({ hamFound: this.ham_found, hamIsSsl: this.ham_is_ssl, ham: ham });

		if (!this.ham_found) {
			this.error =
				'The connection to the HAM agent could not be established. You may try restarting your PC and try again. If this error persists, please contact customer service for assistance.';
			throw new Error('HAM not found');
		}

		try {
			this.deviceDetails = JSON.parse(ham);
		} catch (e) {
			this.error =
				'Issues occured while connecting to the HAM agent. You may try restarting your PC and try again. If this error persists, please contact customer service for assistance.';
			throw new Error('No potable');
		}

		console.log(JSON.parse(ham));

		try {
			let codeResp = await this.getDeviceCode();
			this.deviceCode = JSON.parse(codeResp);
		} catch (e) {
			this.error =
				'Issues occured while communicating to the HAM agent. You may try restarting your PC and try again. If this error persists, please contact customer service for assistance.';
			throw new Error('Extremely bad situation');
		}

		if (!this.deviceCode.verification_url.includes(this.stack)) {
			this.error = 'Please make sure your device is onboarded to the right stack...';
			await new Promise((r) => setTimeout(r, 2750));
		}

		try {
			let authResp = await this.authRequest();
			console.log(JSON.parse(authResp));
			this.error = 'The device seems to already be authorized.';
		} catch (e) {
			if (this.host.includes('fitstation-orthotics')) {
				this.deviceCode.verification_url = this.deviceCode.verification_url.replaceAll(
					'backoffice.dev.fitstation4me.com',
					'admin.dev.fitstation-orthotics.com'
				);
				this.deviceCode.verification_url = this.deviceCode.verification_url.replaceAll(
					'backoffice.stg.fitstation4me.com',
					'admin.stg.fitstation-orthotics.com'
				);
				this.deviceCode.verification_url = this.deviceCode.verification_url.replaceAll(
					'backoffice.fitstation4me.com',
					'admin.fitstation-orthotics.com'
				);
			}

			location.assign(this.deviceCode.verification_url + '?userCode=' + this.deviceCode.user_code + '&return_uri=' + window.location.origin);
		}
	}
}

// const state = new MainStore();
// export default state;
